<template>
  <v-container fluid fill-height>
    <v-layout row justify-center v-if="aboutData.length > 0">
      <v-flex xs12 md6 lg4 xl3 class="hidden-sm-and-down">
        <v-card>
          <v-card-media>
            <img :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + aboutData[0].image "/>
          </v-card-media>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 lg4 xl3>
        <!-- <v-card v-for="(item, index) in aboutData" :key="index" dense color="grey lighten-2"> -->
          <div v-for="(item, index) in aboutData" :key="index" class="about-div">
            <h2 class="display-2">{{ item.title }}</h2>
            <hr class="buzz-hr">
            <p v-for="(para, i) in item.content.split('\n')" :key="i" class="content-text">{{ para }}</p> 
          </div>
        <!-- </v-card> -->
      </v-flex>
        <!-- <v-btn class="primary">Our Services!</v-btn> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      aboutData: []
    }
  },
  beforeMount () {
    this.getAboutData()
  },
  computed: {
    ...mapGetters({
      authUsername: 'adminUser/getAuthUser',
      authPassword: 'adminUser/getAuthPassword'
    })
  },
  methods: {
    getAboutData () {
      const path = '/about'
      const auth = {
        username: this.authUsername,
        passsword: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.aboutData = response.data.about
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
/*.card {
  margin-bottom: 10px;
}*/
/*.about-div {
  padding: 30px 20px; 
}*/
p {
  text-align: justify;
}
.container {
  /*min-height: 58vh;*/
}
</style>


// WEBPACK FOOTER //
// src/components/About.vue